import { useState } from 'react';

export const usePagination = () => {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const onChangePage = (page: number) => {
    setCurrent(page);
  };

  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const onChange = (page: number, size: number) => {
    setCurrent(page);
    setPageSize(size);
  };
  return {
    current,
    pageSize,
    onChangePage,
    onChangePageSize,
    onChange
  };
};
